export const HOME_MATCH_USER_PREFERENCES_LOCATION_CONTENT = {
    LOADING_MESSAGE: "Wyszukiwanie lokalizacji...",
    MIN_INPUT_LENGTH_MESSAGE: "Wpisz co najmniej 2 znaki",
    NO_RESULTS_MESSAGE: "Nie znaleziono lokalizacji",
    PLACEHOLDER: "Wpisz nazwę lokalizacji"
} as const;
export const HOME_MATCH_USER_PREFERENCES_LOCATION_CONTENT = {
    LOADING_MESSAGE: "Wyszukiwanie lokalizacji...",
    MIN_INPUT_LENGTH_MESSAGE: "Wpisz co najmniej 2 znaki",
    NO_RESULTS_MESSAGE: "Nie znaleziono lokalizacji",
    PLACEHOLDER: "Wpisz nazwę lokalizacji"
} as const;
